<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-list-item-avatar class="mb-4" size="80" tile v-if="data.icon">
					<v-img :src="data.icon" contain />
				</v-list-item-avatar>

				<v-file-input
					@change="uploadFile"
					accept="image/png, image/jpeg"
					label="Upload image"
					prepend-icon="mdi-image"
					show-size
				/>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Title is mandatory']"
					class="fullwidth"
					filled
					label="Title"
					prepend-icon="mdi-identifier"
					required
					v-model="data.title"
				></v-text-field>
			</v-list-item-content>
		</v-list-item>

		<v-list-item>
			<v-list-item-content>
				<h3 class="mb-4">
					<v-icon left>mdi-attachment</v-icon> File Attachments
				</h3>
				<Collection
					cols="auto"
					:collection="data.files"
					@change="dataChanged = true"
					dialogWidth="600"
					:form="$options.FileForm"
					title="File Attachment"
					breakpoints="xs12 sm3 md3 lg3 xl2"
					isFileUpload
					hideHelp
				>
					<FileItem slot-scope="{ item }" v-bind="item" />
				</Collection>
			</v-list-item-content>
		</v-list-item>

		<v-list-item>
			<v-list-item-content>
				<h3 class="mb-2"><v-icon left>mdi-text-subject</v-icon> Description</h3>
				<TextEditor v-model="data.text" />
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<h3 class="mb-2">Benefits</h3>
				<Collection
					:collection="data.benefits"
					:form="$options.BenefitForm"
					breakpoints="xs10 sm11 md4 lg4 xl4"
					title="Benefit"
				>
					<ServiceBenefit slot-scope="item" v-bind="item" />
				</Collection>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>


<script>
import TextEditor from '@/components/admin/TextEditor'
import Collection from '@/components/admin/ItemCollection'

import ServiceBenefit from '@/components/n-collections/n-items/ServiceBenefit'
import FileItem from '@/components/n-collections/n-items/FileItem'

import BenefitForm from './BenefitForm'
import FileForm from './FileForm'

import FileService from '@/services/FileService'

export default {
	name: 'ServiceForm',
	BenefitForm,
	FileForm,
	components: {
		TextEditor,
		Collection,
		ServiceBenefit,
		FileItem,
	},
	created() {
		if (!this.data.benefits) this.$set(this.data, 'benefits', [])
	},
	props: {
		data: {
			type: Object,
			default: {
				icon: '',
				title: '',
				text: '',
				benefits: [],
				files: [],
			},
		},
	},
	methods: {
		async uploadFile(file) {
			if (file) {
				const { name } = file
				const result = await FileService.uploadS3(name, file)
				if (result) this.$set(this.data, 'icon', result.path)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
</style>